import $ from "jquery";
import History from "pushstate";
import template from "template";
import storage from "storage";
import c from "common";
import ajax from "ajax";
import modal from "modal";
import "analytics";
import login from "login";
import Bacon from "Bacon.plugins";

var $body = $("body"),
  dateSelect, datePrevNext, clickStreams, ajaxStream;

function getStoredShowPastValue() {
  return storage.get("showPastPrograms") === "true";
}

function showPast(value) {
  var $past = $(".programs-list .past");

  if (!$("#ohjelmaopas-wrapper").hasClass("history")) {
    if (value === true) {
      $past.show();
    } else {
      $past.hide();
    }
    storage.set("showPastPrograms", value);
  }
}

function getLink($element) {
  return $element.is("a") ? $element : $element.parent("a");
}

function currentDate() {
  return $(".date-select").find("#selector-current").attr("data-date");
}

function getDate(event) {
  var $target = getLink($(event.target)),
    date, offset;

  date = $target.attr("data-date");
  if (!date) {
    date = $("#selector-current").attr("data-date");
  }

  offset = $target.attr("data-day-increment");
  if (!offset) {
    offset = 0;
  }

  return [date, offset];
}

function togglePastProgramsCheckbox(dayType) {
  var $pastProgramCheckbox = $('#show-past-programs-filter');

  if (dayType === "today") {
    $pastProgramCheckbox.show();
  } else {
    $pastProgramCheckbox.hide();
  }
}

function isNotDisabled(event) {
  var $target = getLink($(event.target));
  return !$target.hasClass("disabled");
}

function getPrograms(params) {
  if (!c.isArray(params)) {
    params = [currentDate(), 0];
  }
  return ajax.stream({
    url: "/ohjelmaopas/api/schedule/" + params[0] + "/day/" + params[1],
    type: "GET",
    dataType: "json"
  });
}

function getProgram(programId) {
  return ajax.stream({
    url: "/ohjelmaopas/api/ohjelma/" + programId,
    type: "GET",
    dataType: "json"
  });
}

function updateAfterAjax(data) {
  var htmlStream, activeDay = currentDate(),
    url = "/ohjelmaopas/" + data.programs.day.date;
  if (data.programs.showPersonalizedRecordableInfo !== login.isLoggedIn()) {
    login.reload();
  }
  $("#ohjelmaopas-content-partial").fadeTo(300, 0);
  htmlStream = Bacon.combineWith(function (jsonData, contentPartial, programPartial) {
    return contentPartial.render(jsonData, {
      "ohjelmaopas-content-program-partial": programPartial
    });
  }, data.programs, template.get("ohjelmaopas-content-partial"), template.get("ohjelmaopas-content-program-partial"));
  htmlStream.lazyAssign($, "#ohjelmaopas-content-partial", "html");
  template.get("ohjelmaopas-channelslist-partial").combine(data.programs, template.render).lazyAssign($, "#ohjelmaopas-channelslist-partial", "html");

  htmlStream.onValue(function () {
    $("#ohjelmaopas-wrapper").toggleClass("history", data.programs.day.isPast);
    togglePastProgramsCheckbox(data.programs.day.dayType);
    showPast(getStoredShowPastValue());
    $("#selector-current").attr("data-date", data.programs.day.date).html(data.programs.day.localizedDayName + " " + data.programs.day.shortDate);

    $("#programs-date-list li").removeClass("selected").find("a[data-date='" + data.programs.day.date + "']").parent().addClass("selected");
    $("#day-selector-next, #day-selector-prev").removeClass("disabled");
    if ($("#programs-date-list li.selected").next().length === 0) {
      $("#day-selector-next").addClass("disabled");
    }

    var ignorePrevLimit = $("#day-selector-prev").attr("ignore-prev-limit");

    if (typeof ignorePrevLimit === typeof undefined || ignorePrevLimit === false) {
      if ($("#programs-date-list li.selected").prev().length === 0) {
        $("#day-selector-prev").addClass("disabled");
      }
    }

    $("#ohjelmaopas-content-partial").fadeTo(300, 1);

    if (data.programs.day.date !== activeDay) {
      History.replaceState(null, null, url);
    }
  });
}

function updateAfterRecAjax(requestData, responseData) {
  if (requestData.wildcard) {
    ajax.stream({
      url: '/ohjelmaopas/api/record/wildcard/matches',
      type: 'GET',
      dataType: 'json',
      data: {
        channelId: requestData.channelId,
        wildcard: requestData.wildcard
      }
    }).onValue(function (data) {
      updateProgramRecordingIndicator(data);
    });
  } else {
    updateProgramRecordingIndicator(responseData);
  }
  modal.close();
}

function updateProgramRecordingIndicator(programs) {
  for (var i in programs) {
    if (programs.hasOwnProperty(i)) {
      template.get("ohjelmaopas-content-program-partial").combine(programs[i], template.render).lazyAssign($, "#program_" + programs[i].id, "replaceWith");
    }
  }
}

function getInfo(data) {
  return {
    days: data.days,
    epgListView: {
      day: data.programs.day
    },
    channels: data.programs.channels,
    partitionedChannels: data.programs.partitionedChannels,
    rows: data.programs.rows
  };
}

function updateQuickRecForPrograms(programs, $parent) {
  programs.forEach(
    function (program) {
      if (program.recording) {
        $parent.find('span.quick-rec.active[data-program-id="' + program.id + '"]')
          .removeAttr("data-program-id")
          .removeClass()
          .addClass("record");
      }
    });
}

dateSelect = $body.asEventStream("click", "#programs-date-list a");
datePrevNext = $body.asEventStream("click", "#day-selector-prev, #day-selector-next");
clickStreams = dateSelect.merge(datePrevNext).doAction(c.stopEvent).filter(isNotDisabled).map(getDate);
ajaxStream = clickStreams.flatMap(getPrograms).toProperty();
ajaxStream.onValue(updateAfterAjax);

export default {
  info: ajaxStream.map(getInfo),
  showPast: showPast,
  storedShowPast: getStoredShowPastValue,
  update: updateAfterAjax,
  updateOnRec: updateAfterRecAjax,
  get: getPrograms,
  getProgramById: getProgram,
  updateQuickRecForPrograms: updateQuickRecForPrograms
};



// WEBPACK FOOTER //
// ./web/js/ohjelmaopas/programlist.js